<script>
import axios from "axios";

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Member from "@/components/member/index"

/**
 * Register component
 */
export default {
  page: {
    title: "Danh sách thành viên",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Member
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <Member/>
    <!-- end row -->
  </Layout>
</template>